// plugins/utils.js
import * as Utils from '@utils/toolbox.js';

export default {
	install: (app, options) => {
		app.config.globalProperties.$utils = Utils;
	}
};
